import { Component } from 'react';

import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { LoginService } from '../../../services/login.service';
import { UIContext } from '../../../services/ui-context';
import { UrlUtils } from '../../../utils/url.utils';

export default class AccountVerifyPageComponent extends Component {
    verified: boolean;
    error = false;
    @lazyInject(LoginService) private loginService: LoginService;
    @lazyInject(UIContext) private uiContext: UIContext;
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loginService
            .verifyAccount(UrlUtils.getUrlParameter("k"))
            .subscribe(
                () => {
                    this.uiContext.showSuccessDialog(
                        "Success",
                        "Account verified!"
                    );
                    this.verified = true;
                    this.error = false;
                    setTimeout(() => {
                        location.href = "portal";
                    }, 3000);
                    this.forceUpdate();
                },
                err => {
                    this.uiContext.handleError(err);
                    this.verified = false;
                    this.error = err.message;
                    this.forceUpdate();
                }
            );
    }

    getHTML() {
        if (!this.error && this.verified) {
            return <div>Thank you for verifying your account!</div>;
        }
        if (!this.error && !this.verified) {
            return (
                <div>Please wait while we complete account verification!</div>
            );
        }
        if (this.error) {
            return <div>Error occurred! {this.error}.</div>;
        }
    }

    render() {
        return this.getHTML();
    }
}
